export default "/images/7472c89b2b884ac6d087e199fe1fd608.avif";